import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from 'hooks';
import { ROUTES } from 'constants/routes';
import { USER_TYPE } from 'constants/userType';
import { PayloadState } from '../interfaces';

export function PublicRoute() {
  const { user, refreshRequestState } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && refreshRequestState !== PayloadState.rejected) {
      navigate(
        user.type === USER_TYPE.ADMIN
          ? ROUTES.admin_authorized_partners
          : ROUTES.pdf_history,
        { replace: true }
      );
    }
  }, [user]);
}
